import React, { useState } from 'react';
import { AppBar, Box, IconButton, Toolbar, Avatar, Menu, MenuItem, ListItemIcon, Divider } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Person, Logout } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAdminContext } from '../context/AdminContext';
import careoffLogo from '../assets/careoff-logo.svg';

const TopBar = () => {
  const { sidebarOpen, setSidebarOpen } = useAdminContext();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('adminUser');
    navigate('/login');
  };

  const handleProfile = () => {
    navigate('/profile');
    handleMenuClose();
  };

  return (
    <AppBar position="fixed" color="inherit" elevation={0} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, borderBottom: '1px solid', borderColor: 'text.border' }}>
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <IconButton sx={{ px: 1.8 }} color="inherit" onClick={() => setSidebarOpen(!sidebarOpen)} edge="start">
            <MenuIcon />
          </IconButton>
          <Box
            component="img"
            src={careoffLogo}
            alt="CareOff Logo"
            sx={{ height: 36, display: { xs: 'none', sm: 'block' } }}
          />
        </Box>

        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <IconButton onClick={handleMenuOpen} size="small" sx={{ p: 0 }}>
            <Avatar sx={{ bgcolor: 'secondary.main', width: 34, height: 34 }}>A</Avatar>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            onClick={handleMenuClose}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            <MenuItem onClick={handleProfile}>
              <ListItemIcon><Person fontSize="small" color="primary" /></ListItemIcon>
              View Profile
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleLogout}>
              <ListItemIcon><Logout fontSize="small" color="error" /></ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
